import React from 'react'
import '../styles/CaseStudyQuote.scss'

const CaseStudyQuote = (props) => {
    return (
        <div className="quote">
            <div><p>{props.Quote}</p></div>
            <div><p>{props.QuoteSource}</p></div>
        </div>
    )
}

export default CaseStudyQuote;